import React from 'react';
import { SuspenseWrapper } from './SuspenseWrapper';
import LoginOnboardingRedirect from './redirects/LoginOnboardingRedirect';
import RememberMeRedirect from './redirects/RememberMeRedirect';

function RootRoute() {
  return (
    <LoginOnboardingRedirect>
      <RememberMeRedirect>
        <SuspenseWrapper>
          <ProfileView />
        </SuspenseWrapper>
      </RememberMeRedirect>
    </LoginOnboardingRedirect>
  );
}

const ProfileView = React.lazy(() => import('../ProfileView/ProfileView'));

export default RootRoute;
